import { DestroyRef, inject, Injectable, signal, WritableSignal } from '@angular/core';
import { filter } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActionModel } from '@models/admin/action.model';

@Injectable()
export class ModalWindowService {

  private readonly router = inject(Router);
  private readonly destroy$ = inject(DestroyRef);

  public modalUrls = signal([]);

  public redirected = signal(false);

  public formMethod: WritableSignal<ActionModel | null> = signal(null);

  methodAfterForm!: any;

  constructor() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed(this.destroy$),
    ).subscribe(() => this.clearModalUrls());
  }

  addModalUrl(url: string, id?: string, modal?: boolean) {
    console.log('modalUrl', url);
    console.log('modalUrl', id);
    console.log('modalUrl', modal);
    modal ? this.modalUrls.update(urls => [...urls, url + id]) :
      this.modalUrls.update(urls => [...urls, id !== undefined ? url + '?id=' + id : url]);
  }

  removeModalUrl() {
    this.modalUrls.update(urls => urls.slice(0, -1));
  }

  clearModalUrls() {
    this.modalUrls.set([]);
  }

  setRedirected(value: boolean) {
    this.redirected.set(value);
  }

  setFormMethod(method: ActionModel) {
    this.formMethod.set(method);
  }

  clearFormMethod() {
    this.methodAfterForm = undefined;

    this.formMethod.set(null);
  }

  getUrlsCount() {
    return this.modalUrls().length;
  }

  getLastModalUrl() {
    return this.modalUrls()[this.modalUrls().length - 1] ?? '';
  }

  getLastUrl() {
    return this.modalUrls()[this.modalUrls().length - 1].split('?')[0] ?? '';
  }

  getLastParams() {
    return { id: this.modalUrls()[this.modalUrls().length - 1].split('=')[1] ?? '' };
  }
}
